import React, { useMemo, useState } from 'react';
import { Popover } from '@mui/material';
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import { useTranslation } from 'react-i18next';
import Typography from '@src/new-components/Typography';
import CommonButton from '@src/new-components/Button';
import { COLOR } from '@src/styles/color';
import NewFeature from '@src/new-components/Chip/NewFeature';
import {
  StyledStartVoicePopoverItem,
  StyledStartVoicePopoverMenu,
} from './index.style';

const StartVoiceCloningAction = ({
  isValidNumberOfVoicesCanUse,
  handleValidateNumberClonedVoice,
  handleOpenPopupProfessionalVoiceCloneUpload,
  handleOpenQR,
  onOpenProvideEmailDialog,
  hasProvidedEmail,
  apiTtsSttLaunchEnabled,
}) => {
  const { t } = useTranslation();
  const [anchor, setAnchor] = useState(null);

  const startVoiceCloningMenuItems = useMemo(
    () => [
      {
        label: t('uploadFile'),
        value: 'upload',
        isNewFeature: !apiTtsSttLaunchEnabled,
      },
      {
        label: t('record'),
        value: 'record',
      },
    ],
    [t],
  );

  const handleCloseMenu = () => setAnchor(null);

  const handleButtonClick = (event) => {
    if (!hasProvidedEmail) {
      onOpenProvideEmailDialog();
      return;
    }

    if (!isValidNumberOfVoicesCanUse) {
      handleValidateNumberClonedVoice();
      return;
    }

    if (anchor) {
      handleCloseMenu();
      return;
    }

    setAnchor(event.currentTarget);
  };

  const handleSelectVoiceCloningMethod = async (method) => {
    handleCloseMenu();

    if (method === 'upload') {
      handleOpenPopupProfessionalVoiceCloneUpload();
      return;
    }

    await handleOpenQR();
  };

  return (
    <>
      <div className="action-wrapper">
        <CommonButton
          variant="contained"
          color="primary"
          size="large"
          textProps={{
            variantText: 'body-14-medium',
            color: COLOR.secondary[100],
          }}
          customStyle={{
            padding: '0px',
            height: '40px',
            borderRadius: '8px',
            width: '156px',
          }}
          onClick={handleButtonClick}
          endIcon={
            <ArrowDropDownRoundedIcon
              sx={{
                width: 24,
                height: 24,
                color: COLOR.indigo.default,
                transform: anchor ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.2s ease',
              }}
            />
          }
        >
          {t('startVoiceCloning')}
        </CommonButton>
      </div>

      <Popover
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            borderRadius: '12px',
            boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.08)',
            padding: 0,
            marginTop: '8px',
            maxWidth: anchor?.offsetWidth,
          },
        }}
      >
        <StyledStartVoicePopoverMenu width={anchor?.offsetWidth}>
          {startVoiceCloningMenuItems.map((item) => (
            <StyledStartVoicePopoverItem
              type="button"
              key={item.value}
              onClick={() => handleSelectVoiceCloningMethod(item.value)}
            >
              <Typography variant="body-14-medium" color={COLOR.label2[100]}>
                {item.label}
              </Typography>
              {item?.isNewFeature && <NewFeature />}
            </StyledStartVoicePopoverItem>
          ))}
        </StyledStartVoicePopoverMenu>
      </Popover>
    </>
  );
};

export default StartVoiceCloningAction;
